export enum WarrantySegmentationModeName {
  quoteForm = "quoteForm",
  estimatedCoverageOption = "estimatedCoverageOption",
  quoteVehicleForm = "quoteVehicleForm",
  quotePersonalForm = "quotePersonalForm",
}

export type WarrantySegmentationMode = {
  name: WarrantySegmentationModeName;
};

export const estimatedCoverageOptionMode: WarrantySegmentationMode = {
  name: WarrantySegmentationModeName.estimatedCoverageOption,
};

export const quoteVehicleFormMode: WarrantySegmentationMode = {
  name: WarrantySegmentationModeName.quoteVehicleForm,
};

export const quotePersonalFormMode: WarrantySegmentationMode = {
  name: WarrantySegmentationModeName.quotePersonalForm,
};
